module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('ul', {
    staticClass: "list-group user-account-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [(_vm.last_nm) ? _c('div', [(_vm.visible_user_is_sys_admin) ? _c('span', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showUserList($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.last_nm) + ", " + _vm._s(_vm.first_nm) + " ")])]) : _c('span', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.last_nm) + ", " + _vm._s(_vm.first_nm) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_locked == 1),
      expression: "is_locked == 1"
    }],
    staticClass: "label label-locked m-l-5"
  }, [_c('span', {
    staticClass: "fa fa-lock m-r-5"
  }), _vm._v(" Locked")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status_cd == 'IN'),
      expression: "status_cd == 'IN'"
    }],
    staticClass: "label label-inactive m-l-5"
  }, [_c('span', {
    staticClass: "fa fa-user m-r-5"
  }), _vm._v(" Inactive")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPendingApproval),
      expression: "hasPendingApproval"
    }],
    staticClass: "label label-warning m-l-5"
  }, [_vm._v("Waiting Approval")])]) : _c('div', [(_vm.visible_user_is_sys_admin) ? _c('span', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showUserList($event)
      }
    }
  }, [_vm._v("No User Details")])]) : _c('span', [_vm._v("\n\t\t\t\t\t\t\tNo User Details\n\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_locked == 1),
      expression: "is_locked == 1"
    }],
    staticClass: "label label-locked m-l-5"
  }, [_c('span', {
    staticClass: "fa fa-lock m-r-5"
  }), _vm._v(" Locked")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status_cd == 'IN'),
      expression: "status_cd == 'IN'"
    }],
    staticClass: "label label-inactive m-l-5"
  }, [_c('span', {
    staticClass: "fa fa-user m-r-5"
  }), _vm._v(" Inactive")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPendingApproval),
      expression: "hasPendingApproval"
    }],
    staticClass: "label label-warning m-l-5"
  }, [_vm._v("Waiting Approval")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.email
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-envelope-o m-r-5"
  }), _vm._v(_vm._s(_vm.email))]), _vm._v(" " + _vm._s(_vm.user_details) + "\n\t\t\t\t\t"), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.last_nm),
      expression: "last_nm"
    }]
  }, [_vm._v("Last Login: " + _vm._s((_vm.last_login_ts ? _vm.last_login_ts : 'Never')))])]), _vm._v(" "), _vm._l((_vm.filtered_roles), function(role, index) {
    return _c('account-role-item', {
      attrs: {
        "type": 'approval',
        "role_cd": role.role_cd,
        "role_desc": role.role_desc,
        "user_account_roles": _vm.local_roles_array,
        "source": 'account',
        "is_unavailable": _vm.isRoleUnavailable(role.role_cd)
      },
      on: {
        "add": function($event) {
          return _vm.addRolesArray(index)
        },
        "delete": function($event) {
          return _vm.deleteRolesArray(index)
        }
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 m-t-15"
  }, [(_vm.form_errors.length) ? _c('span', {
    staticClass: "simple-error"
  }, [_vm._v(" " + _vm._s(_vm.form_errors) + " ")]) : _vm._e(), _vm._v(" "), (_vm.form_status) ? _c('span', {
    staticClass: "simple-status"
  }, [_vm._v(" " + _vm._s(_vm.form_status) + " ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 m-t-15"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rolesChanged),
      expression: "rolesChanged"
    }],
    staticClass: "btn btn-primary btn-bold m-l-10",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.savePermissions
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("Save Changes\n\t\t\t\t")]), _vm._v(" "), (_vm.hasPendingApproval && !_vm.rolesChanged) ? _c('button', {
    staticClass: "btn btn-warning btn-bold m-l-10",
    attrs: {
      "disabled": _vm.saveDisabled
    },
    on: {
      "click": _vm.savePermissions
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v("Deny Approvals\n\t\t\t\t")]) : _vm._e()])])]), _vm._v(" "), _c('hr')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1cab9ad2!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/admin-user-role-list.vue
// module id = JbWS
// module chunks = 0